(function($){
    var first_time_transaction_load = 0;
  	var first_time_transaction_load_1 = 0;
    $(document).ready(function () {
        $('.krng-nav-link').on('click', function() {
          $('.krng-nav-link').removeClass('active')
          $(this).addClass('active')
          $('.tab-pane').removeClass('show active').hide()
          $(`#${$(this).data('href').substring(1)}`).fadeIn()
        });

      	var kringle_client_id = 10353;
		var customer_email = $("#customer_email").val();
        var customer_id = $("#customer_id").val();
        var customer_full_name = $("#customer_full_name").val();
      
      var kringle_widget_theme_type = 'logout';
      if(customer_email != undefined && customer_id != undefined){
        kringle_widget_theme_type = 'login';
      }
      
      /**
      * @desc Get Customer Transactions
      */
      if(kringle_widget_theme_type == 'login'){
        // check if refferal already applied then dont show the referral widget
        check_referral_already_applied();
        function check_referral_already_applied(){
          	// Get all the customer transactions
            var request_obj = $.ajax({
              url: "https://cms-platform-api-ap-southeast-1-prod.kringle.in/v1/fans/adapters/shopify/check_referral_applied", type: "POST",
              headers: {'Authorization': "MDg2MmYyNzY1YWMxOGQ3NDM2MTZjMWJiNTliZTljMDQjJCMwMjhkNDA5MDRjZDQ0ODVkMDMyMjgzYWViZTY4N2U3Mg=="},
              data: {"mobapp_id" : kringle_client_id, "email": customer_email, "id": customer_id},
              dataType: "json"
            });
            request_obj.done(function(api_resp) {
              if(api_resp.status == 200){
                
                $("#loyalty_referral_code").html("Your Referral Code : " + api_resp.data.referral_code).show();
                $("#loyalty_referral_code_value").html(api_resp.data.referral_code);
                $("input#loyalty_referral_code_value").val(api_resp.data.referral_code);
                $("#loyalty_total_reffered").html(api_resp.data.total_reffered);
                if(api_resp.data.already_applied){
                	$("#kringle_referral_code_div").hide();
                }else{
                	$("#kringle_referral_code_div").show();
                }
//                 var krng_social_share_div_html = $("#krng_social_share_div").html().replace(/<loyalty_referral_code_value>/g,api_resp.data.referral_code);
// 				$("#krng_social_share_div").html(krng_social_share_div_html);
              }
            });
            request_obj.fail(function(jqXHR, textStatus, errorThrown) {
            });
        }
        
        // Apply Referral Code
        $("#kringle_referral_code_btn").on('click', function(){
          	if($("#kringle_referral_code_btn").text() == 'Applying...' ){
              alert('Request already in process.');
              return false;
            }
          	$("#kringle_referral_apply_message").hide();
          	var kringle_referral_code = $("#kringle_referral_code").val();
            if($.trim(kringle_referral_code) == ''){
              	$("#kringle_referral_code").val('').focus();
				return false;
            }
          
          	$("#kringle_referral_code_btn").text('Applying...');
          
          	// Get all the customer transactions
            var request_obj = $.ajax({
              url: "https://cms-platform-api-ap-southeast-1-prod.kringle.in/v1/fans/adapters/shopify/apply_referral_code", type: "POST",
              headers: {'Authorization': "MDg2MmYyNzY1YWMxOGQ3NDM2MTZjMWJiNTliZTljMDQjJCMwMjhkNDA5MDRjZDQ0ODVkMDMyMjgzYWViZTY4N2U3Mg=="},
              data: {
                "mobapp_id" : kringle_client_id, "email": customer_email, 
                "id": customer_id, "referral_code":kringle_referral_code
              },
              dataType: "json"
            });
          	
            request_obj.done(function(api_resp) {
              $("#kringle_referral_code_btn").text('Apply');
              if(api_resp.status == 200){
                $("#kringle_referral_code").val('');
                $("#kringle_referral_apply_message").text("Referral code applied successfully! Your 500 Glam Points will reflect after your first purchase.").show().css('color', 'green');
                
                var ev = {};
                ev.eventInfo={
                'type':ctConstants.trackEvent,
                'eventAction': ctConstants.loyaltyReferralCode,
                'eventLabel' : 'Loyalty Referral Code Applied',
                'eventValue' : 1 };
                ev.category ={'primaryCategory':ctConstants.other};   
                digitalData.event.push(ev);
                
              }else{
                $("#kringle_referral_code").val('');
                $("#kringle_referral_apply_message").text(api_resp.message).show().css('color', 'red');
                
                // Apply Referral Errors Analytics
                var ev = {};
                ev.eventInfo={
                    'type':ctConstants.trackEvent,
                    'eventAction': ctConstants.inputerror,
                    'eventLabel' : 'LOYALTY - Referral Error | ' + api_resp.message,
                    'eventValue' : "1"
                    };
                ev.category ={'primaryCategory':ctConstants.custom};       
                ev.subcategory = 'Error';
                digitalData.event.push(ev);
                
              }
            });
            request_obj.fail(function(jqXHR, textStatus, errorThrown) {
              $("#kringle_referral_code_btn").text('Apply');
            });
          
        });
        
        var page_quantity = 10;
		// Get all the customer transactions
        get_credited_transactions(page_quantity);
        
        function get_credited_transactions(page_quantity){
          var request_obj = $.ajax({
            url: "https://kringle-loyalty-api-ap-southeast-1-prod.kringle.in/v1/loyalties/shopify/transactions/points", type: "POST",
            headers: {'Authorization': "MDg2MmYyNzY1YWMxOGQ3NDM2MTZjMWJiNTliZTljMDQjJCMwMjhkNDA5MDRjZDQ0ODVkMDMyMjgzYWViZTY4N2U3Mg=="},
            data: {
              "mobapp_id" : kringle_client_id, "email": customer_email, "s_customer_id": customer_id,
              "page":"1", "quantity":page_quantity
            },
            dataType: "json"
          });
          request_obj.done(function(api_resp) {
            if(api_resp.status == 200){
              var total_transactions = api_resp.data.transactions.total;
              var total_pages = api_resp.data.transactions.total_pages;
              var krng_trans = api_resp.data.transactions.data;
              $("#total_pages").val(total_pages);

              var innert_html = "";
              var transaction_html = "";
              $.each(krng_trans, function (i) {
                var row = krng_trans[i];
                
                var order_id = row.order_id;
                if(row.zomato_order_id){
                  order_id = "<a class='krng-shopify-order-link' target='_blank' href='/account/orders/" + row.zomato_order_id + "'>" + order_id + "</a>";
                }

                var _desc = row.description;
                var _final_desc = _desc.charAt(0).toUpperCase() + _desc.slice(1);

                var _date = new Date(row.created);

                var txn_month  = _date.toLocaleString('default', { month: 'short' });
                var txn_day = _date.getDate();
                txn_day = txn_day > 9 ? txn_day : '0' + txn_day;

                var txn_hrs = _date.getHours();
                txn_hrs = txn_hrs > 9 ? txn_hrs : '0' + txn_hrs;

                var txn_min = _date.getMinutes();
                txn_min = txn_min > 9 ? txn_min : '0' + txn_min;

                // get AM / PM values
                var _ampm = _date.getHours() >= 12 ? ' PM' : ' AM';
                // format full date
                var _final_date = txn_month + " " + txn_day + ", " + _date.getFullYear() + ' ' + [txn_hrs, txn_min].join(':') + _ampm;

                transaction_html += "<tr><td>"+_final_date+"</td><td>"+_final_desc+"</td><td>"+order_id+"</td><td>"+row.points+"</td></tr>";
              });
              innert_html += transaction_html;
              $("#credited_transactions_div_body").html(innert_html);

              // Kringle paging generator
              if(total_pages > 0){
                create_pagination_credited(total_pages, page_quantity);
              }
            }

          });
          request_obj.fail(function(jqXHR, textStatus) {
            $("#credited_transactions_div_body").text('');
          });
        }

		// create the pagination
        function create_pagination_credited(total_pages, page_quantity){
          $('#krigle-pagination-credited').twbsPagination({
            totalPages: total_pages, visiblePages: 6,
            next: 'Next', prev: 'Prev',
            onPageClick: function (event, page) {
              if(first_time_transaction_load > 0){
                $("#credited_transactions_div_body").css('background', 'transparent').css('opacity', '.2');
                var customer_email = $("#customer_email").val();
                var customer_id = $("#customer_id").val();

                var request_obj = $.ajax({
                  url: "https://kringle-loyalty-api-ap-southeast-1-prod.kringle.in/v1/loyalties/shopify/transactions/points", type: "POST", dataType: "json",
                  headers: {'Authorization': "MDg2MmYyNzY1YWMxOGQ3NDM2MTZjMWJiNTliZTljMDQjJCMwMjhkNDA5MDRjZDQ0ODVkMDMyMjgzYWViZTY4N2U3Mg=="},
                  data: {
                    "mobapp_id" : kringle_client_id, "email": customer_email, "s_customer_id": customer_id,
                    "page": page, "quantity":page_quantity
                  }
                });

                request_obj.done(function(api_resp) {
                  if(api_resp.status == 200){
                    var total_transactions = api_resp.data.transactions.total;
                    var total_pages = api_resp.data.transactions.total_pages;
                    var krng_trans = api_resp.data.transactions.data;
                    $("#total_pages").val(total_pages);

                    var innert_html = "";
                    var transaction_html = "";
                    $.each(krng_trans, function (i) {
                      var row = krng_trans[i];
                      var order_id = row.order_id;
                      if(row.zomato_order_id){
                          order_id = "<a class='krng-shopify-order-link' target='_blank' href='/account/orders/" + row.zomato_order_id + "'>" + order_id + "</a>";
                      }
                      var _desc = row.description;
                      var _final_desc = _desc.charAt(0).toUpperCase() + _desc.slice(1);

                      var _date = new Date(row.created);
                      var txn_month  = _date.toLocaleString('default', { month: 'short' });
                      var txn_day = _date.getDate();
                      txn_day = txn_day > 9 ? txn_day : '0' + txn_day;

                      var txn_hrs = _date.getHours();
                      txn_hrs = txn_hrs > 9 ? txn_hrs : '0' + txn_hrs;

                      var txn_min = _date.getMinutes();
                      txn_min = txn_min > 9 ? txn_min : '0' + txn_min;

                      // get AM / PM values
                      var _ampm = _date.getHours() >= 12 ? ' PM' : ' AM';
                      // format full date
                      var _final_date = txn_month + " " + txn_day + ", " + _date.getFullYear() + ' ' + [txn_hrs, txn_min].join(':') + _ampm;

                      transaction_html += "<tr><td>"+_final_date+"</td><td>"+_final_desc+"</td><td>"+order_id+"</td><td>"+row.points+"</td></tr>";
                    });

                    innert_html += transaction_html;
                    $("#credited_transactions_div_body").html(innert_html);
                    $("#credited_transactions_div_body").css('opacity', '1');
                  }
                });

                request_obj.fail(function(jqXHR, textStatus) {
                  $("#credited_transactions_div_body").text('');
                  $("#credited_transactions_div_body").css('opacity', '1');
                });
              }
              first_time_transaction_load++;
            }
          });
        }
        
        
        // Get all the customer's to be credited transactions
        get_to_be_credited_transactions(page_quantity);
        
        function get_to_be_credited_transactions(page_quantity){
          var request_obj = $.ajax({
            url: "https://kringle-loyalty-api-ap-southeast-1-prod.kringle.in/v1/loyalties/shopify/transactions/delayed_points", type: "POST",
            headers: {'Authorization': "MDg2MmYyNzY1YWMxOGQ3NDM2MTZjMWJiNTliZTljMDQjJCMwMjhkNDA5MDRjZDQ0ODVkMDMyMjgzYWViZTY4N2U3Mg=="},
            data: {
              "mobapp_id" : kringle_client_id, "email": customer_email, "s_customer_id": customer_id,
              "page":"1", "quantity":page_quantity
            },
            dataType: "json"
          });
          request_obj.done(function(api_resp) {
            if(api_resp.status == 200){
              var total_transactions = api_resp.data.transactions.total;
              var total_pages = api_resp.data.transactions.total_pages;
              var krng_trans = api_resp.data.transactions.data;
              $("#total_pages_to_be_credited").val(total_pages);

              var innert_html = "";
              var transaction_html = "";
              $.each(krng_trans, function (i) {
                var row = krng_trans[i];

                var order_id = row.order_id;
                if(row.zomato_order_id){
                	order_id = "<a class='krng-shopify-order-link' target='_blank' href='/account/orders/" + row.zomato_order_id + "'>" + order_id + "</a>";
                }
                
                var _desc = row.description;
                var _final_desc = _desc.charAt(0).toUpperCase() + _desc.slice(1);

                var _date = new Date(row.credit_delayed_date);
                
                _date.setTime(_date.getTime() + (330*60*1000))

                var txn_month  = _date.toLocaleString('default', { month: 'short' });
                var txn_day = _date.getDate();
                txn_day = txn_day > 9 ? txn_day : '0' + txn_day;

                var txn_hrs = _date.getHours();
                txn_hrs = txn_hrs > 9 ? txn_hrs : '0' + txn_hrs;

                var txn_min = _date.getMinutes();
                txn_min = txn_min > 9 ? txn_min : '0' + txn_min;

                // get AM / PM values
                var _ampm = _date.getHours() >= 12 ? ' PM' : ' AM';
                // format full date
                var _final_date = txn_month + " " + txn_day + ", " + _date.getFullYear() + ' ' + [txn_hrs, txn_min].join(':') + _ampm;

                transaction_html += "<tr><td>"+_final_date+"</td><td>"+_final_desc+"</td><td>"+order_id+"</td><td>"+row.points+"</td></tr>";
              });
              innert_html += transaction_html;
              $("#to_be_credited_transactions_div_body").html(innert_html);

              // Kringle paging generator
              if(total_pages > 0){
                create_pagination_to_be_credited(total_pages, page_quantity);
              }
            }

          });
          request_obj.fail(function(jqXHR, textStatus) {
            $("#to_be_credited_transactions_div_body").text('');
          });
        }
        
        function create_pagination_to_be_credited(total_pages, page_quantity){
          $('#krigle-pagination-to-be-credited').twbsPagination({
            totalPages: total_pages, visiblePages: 6,
            next: 'Next', prev: 'Prev',
            onPageClick: function (event, page) {
              if(first_time_transaction_load_1 > 0){
                $("#to_be_credited_transactions_div_body").css('background', 'transparent').css('opacity', '.2');
                var customer_email = $("#customer_email").val();
                var customer_id = $("#customer_id").val();

                var request_obj = $.ajax({
                  url: "https://kringle-loyalty-api-ap-southeast-1-prod.kringle.in/v1/loyalties/shopify/transactions/delayed_points", type: "POST", dataType: "json",
                  headers: {'Authorization': "MDg2MmYyNzY1YWMxOGQ3NDM2MTZjMWJiNTliZTljMDQjJCMwMjhkNDA5MDRjZDQ0ODVkMDMyMjgzYWViZTY4N2U3Mg=="},
                  data: {
                    "mobapp_id" : kringle_client_id, "email": customer_email, "s_customer_id": customer_id,
                    "page": page, "quantity":page_quantity
                  }
                });

                request_obj.done(function(api_resp) {
                  if(api_resp.status == 200){
                    var total_transactions = api_resp.data.transactions.total;
                    var total_pages = api_resp.data.transactions.total_pages;
                    var krng_trans = api_resp.data.transactions.data;
                    $("#total_pages_to_be_credited").val(total_pages);

                    var innert_html = "";
                    var transaction_html = "";
                    $.each(krng_trans, function (i) {
                      var row = krng_trans[i];
                      var order_id = row.order_id;
                      if(row.zomato_order_id){
                          order_id = "<a class='krng-shopify-order-link' target='_blank' href='/account/orders/" + row.zomato_order_id + "'>" + order_id + "</a>";
                      }
                      var _desc = row.description;
                      var _final_desc = _desc.charAt(0).toUpperCase() + _desc.slice(1);

                      var _date = new Date(row.credit_delayed_date);
                      var txn_month  = _date.toLocaleString('default', { month: 'short' });
                      var txn_day = _date.getDate();
                      txn_day = txn_day > 9 ? txn_day : '0' + txn_day;

                      var txn_hrs = _date.getHours();
                      txn_hrs = txn_hrs > 9 ? txn_hrs : '0' + txn_hrs;

                      var txn_min = _date.getMinutes();
                      txn_min = txn_min > 9 ? txn_min : '0' + txn_min;

                      // get AM / PM values
                      var _ampm = _date.getHours() >= 12 ? ' PM' : ' AM';
                      // format full date
                      var _final_date = txn_month + " " + txn_day + ", " + _date.getFullYear() + ' ' + [txn_hrs, txn_min].join(':') + _ampm;

                      transaction_html += "<tr><td>"+_final_date+"</td><td>"+_final_desc+"</td><td>"+order_id+"</td><td>"+row.points+"</td></tr>";
                    });

                    innert_html += transaction_html;
                    $("#to_be_credited_transactions_div_body").html(innert_html);
                    $("#to_be_credited_transactions_div_body").css('opacity', '1');
                  }
                });

                request_obj.fail(function(jqXHR, textStatus) {
                  $("#to_be_credited_transactions_div_body").text('');
                  $("#to_be_credited_transactions_div_body").css('opacity', '1');
                });
              }
              first_time_transaction_load_1++;
            }
          });
        }
      
      }

    });
  
})(jQuery);